// @figma file=nq2oTuNpAeyLOoF0tXtO32 node=14860-69258 name="Skeleton" set="shadcn-studio-pro-v5" verified=2026-03-16
import * as React from 'react';
import { cn } from '../../lib/utils';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    role="status"
    aria-busy="true"
    aria-label="Loading…"
    className={cn('animate-pulse rounded bg-muted', className)}
    {...props}
  />
));
Skeleton.displayName = 'Skeleton';

export { Skeleton };
